import React, { forwardRef } from 'react';
import clsx from 'clsx';

import { Element } from '../element';
import * as styles from './spinner.styles';

/** @type {import(".").SpinnerType} */
const Spinner = forwardRef(({ className, size, ...props }, ref) => {
  return (
    <Element ref={ref} as="svg" viewBox="0 0 50 50" className={clsx(styles.spinner, className)} {...props}>
      <circle
        className={styles.components.circle}
        cx="25"
        cy="25"
        r="22"
        strokeMiterlimit="10"
        style={{
          strokeWidth: size,
        }}
      />
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Spinner.displayName = 'Spinner';
}

export default Spinner;
